import { property, State } from '@common/lit/store';
import type { TemplateTheme } from '@common/lit/TemplateResolver';
import { randomId } from '@common/utils/randomId';

export class ConfigStore extends State {
  [key: string | symbol]: unknown;

  // The EIAM access token used by the agent in Marquez
  @property({ value: undefined }) accessToken?: string;

  // The URL of api4p to use
  @property({ value: undefined }) apiUrl!: string;

  // Service Provider ID and Local Customer ID
  @property({ value: undefined }) spId!: string;
  @property({ value: undefined }) lcId!: string;

  // Theme (default: occl)
  @property({ value: 'occl' }) theme!: TemplateTheme;

  // URL to fetch the resources for the theme from, eg.
  // https://dev-library.telefonica.de/1 or
  // https://library.telefonica.de/1
  @property({ value: undefined }) themeBaseUrl!: string;

  // alternative fetch method, needed by some salesforce clients
  @property({ value: undefined }) fetch?: string;

  // A traceid generated by the integrating portal or by COMS if not present
  @property({ value: randomId() }) traceid!: string;
}

export const store = new ConfigStore();
